import { scrollToId } from "@/App";
import { CONTACT } from "@/data/content";
import { SocialIcons } from "@/components/Socials";

const Footer = () => (
  <footer data-testid="site-footer" className="grain-overlay relative border-t border-gold/20 bg-navy py-14">
    <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3">
          <img
            data-testid="footer-logo"
            src="/logo.webp"
            alt="P.A. International logo"
            className="h-16 w-auto rounded-sm bg-white p-1"
          />
          <span className="wordmark text-[30px] uppercase leading-none tracking-[0.04em] text-champagne">
            International
          </span>
        </div>
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
          Family-owned handloom fabric manufacturer and exporter. Bhagalpur, Bihar — since 1991.
        </p>
        <SocialIcons className="mt-6" testPrefix="footer-social" />
      </div>
      <div>
        <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-champagne">Explore</p>
        <div className="mt-4 grid grid-cols-2 gap-2">
          {["about", "heritage", "fabrics", "process", "quality", "gallery", "markets", "contact"].map((id) => (
            <button
              key={id}
              data-testid={`footer-link-${id}`}
              onClick={() => scrollToId(`#${id}`)}
              className="text-left text-sm capitalize text-slate-400 transition-colors hover:text-gold"
            >
              {id}
            </button>
          ))}
        </div>
      </div>
      <div>
        <p className="text-[10px] font-semibold uppercase tracking-[0.3em] text-champagne">Export Desk</p>
        <p className="mt-4 text-sm text-slate-400">{CONTACT.email}</p>
        <p className="mt-1 text-sm text-slate-400">{CONTACT.emailAlt}</p>
        <p className="mt-1 text-sm text-slate-400">{CONTACT.phone}</p>
        <a
          data-testid="footer-secondary-mobile-link"
          href="tel:+919433009202"
          className="mt-1 block text-sm text-slate-400 transition-colors hover:text-gold"
        >
          +91 94330 09202
        </a>
        <p className="mt-1 text-sm text-slate-400">{CONTACT.hours}</p>
      </div>
    </div>
    <div className="mx-auto mt-12 flex max-w-7xl flex-col items-start justify-between gap-3 border-t border-white/10 px-5 pt-6 text-xs text-slate-500 sm:flex-row sm:items-center sm:px-8">
      <span>© 2026 P.A. International. All rights reserved.</span>
      <span className="font-serif italic text-gold/80">Woven in Bhagalpur — endless possibilities.</span>
    </div>
  </footer>
);

export default Footer;
